import { DifficultyChip, QuestionTypeChip } from '@exam-management/components';
import { Link } from '@exam-management/router';
import { ReviewResultBadge } from '@exam-management/task-management';
import {
  Chip,
  Text,
  type GridColDef,
  EllipsisText,
  IconButton,
  OpenInNewOutlinedIcon,
} from '@shared/components';

import { type QuestionListDataGridRow } from './types';

export const columns: GridColDef<QuestionListDataGridRow>[] = [
  {
    field: 'no',
    headerName: 'No.',
    align: 'center',
    headerAlign: 'center',
    width: 60,
    sortable: false,
  },
  {
    field: 'qId',
    headerName: 'QID',
    width: 210,
    sortable: false,
  },
  {
    field: 'locationName',
    headerName: 'Location',
    flex: 1,
    minWidth: 152,
    renderCell: ({ row }) => <EllipsisText>{row.locationName}</EllipsisText>,
    sortable: false,
  },
  {
    field: 'type',
    headerName: 'Question Type',
    minWidth: 128,
    renderCell: ({ row }) => (
      <QuestionTypeChip
        type={row.type}
        {...(row.type === 'item-set' ? { questionSize: row.itemSetCount } : {})}
      />
    ),
    sortable: false,
  },
  {
    field: 'itemSetName',
    headerName: 'Item Set Name',
    flex: 1,
    minWidth: 152,
    renderCell: ({ row }) => {
      if (row.type !== 'item-set') {
        return <EllipsisText>-</EllipsisText>;
      }

      return <EllipsisText>{row.itemSetName ?? '-'}</EllipsisText>;
    },
    sortable: false,
  },
  {
    field: 'calculateType',
    headerName: 'Type',
    minWidth: 100,
    renderCell: ({ row }) =>
      row.calculateType ? (
        <Chip
          sx={(theme) => ({
            p: theme.spacing(0.5, 2),
          })}
          label={<Text variant='captionSemibold'>{row.calculateType}</Text>}
        />
      ) : (
        '-'
      ),
    sortable: false,
  },
  {
    field: 'difficultyType',
    headerName: 'Difficulty',
    width: 100,
    renderCell: ({ row }) => <DifficultyChip type={row.difficultyType} />,
    sortable: false,
  },
  {
    field: 'reviewResult',
    headerName: 'Review Result',
    width: 158,
    renderCell: ({ row }) =>
      row.reviewResult ? <ReviewResultBadge result={row.reviewResult} /> : '-',
    sortable: false,
  },
  {
    field: 'moreActions',
    headerName: '',
    width: 48,
    renderCell: ({ row }) => (
      <IconButton
        component={Link}
        to={row.goToPath}
        params={{
          questionId: row.questionId,
          taskId: row.taskId,
        }}
        target='_blank'
        rel='noopener noreferrer'
        onClick={(e) => {
          e.stopPropagation();
        }}
        disableRipple
      >
        <OpenInNewOutlinedIcon sx={(theme) => ({ color: theme.palette.grey[500] })} />
      </IconButton>
    ),
    sortable: false,
  },
];
